import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef, useState } from "react";

const STORAGE_KEY = "lojaSelecionada";

function safeParse(raw) {
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function useLojaSelecionada() {
  const query = useQuery({
    queryKey: ["lojaSelecionada"],
    queryFn: async () => {
      const v = safeParse(window.localStorage.getItem(STORAGE_KEY));
      return v && typeof v === "object" ? v : null;
    },
    staleTime: Infinity,
    gcTime: Infinity,
  });

  const prevRef = useRef(undefined);
  const [changeCount, setChangeCount] = useState(0);

  useEffect(() => {
    const current = query.data?.id ?? null;
    const prev = prevRef.current ?? null;

    if (prevRef.current === undefined) {
      prevRef.current = current;
      return;
    }

    if (current !== prev) {
      prevRef.current = current;
      setChangeCount((c) => c + 1);
    }
  }, [query.data?.id]);

  return {
    ...query,
    foiAlterada: changeCount > 0,
    changeCount,
  };
}

export function useSetLojaSelecionada() {
  const qc = useQueryClient();

  return (loja) => {
    const payload =
      loja && typeof loja === "object"
        ? {
            id: String(loja.id || ""),
            nome: String(loja.nome || ""),
            cnpj: String(loja.cnpj || ""),
          }
        : null;

    if (payload?.id) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }

    qc.setQueryData(["lojaSelecionada"], payload);
  };
}

export function useClearLojaSelecionada() {
  const setLoja = useSetLojaSelecionada();
  return () => setLoja(null);
}